import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ButtonPrimary, ButtonBrand } from "Components/Button";
import axios from "axios";

const AgentEnquirySuccess = ({ rfpId, token }) => {
  const [assigning, setAssigning] = useState(false);
  const [assigned, setAssigned] = useState(false);
  const [error, setError] = useState(false);

  const handleSendToVenues = async () => {
    setAssigning(true);
    setError(false);
    try {
      await axios.post(
        `${window.API}/rfp/enquiry/${rfpId}/send-to-all-venues`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setAssigned(true);
    } catch {
      setError(true);
    }
    setAssigning(false);
  };

  return (
    <div>
      <p className="mb-6">
        Thank you for your enquiry. Please choose whether to auto-assign,
        request commission and send directly to the venues to respond, or
        choose to manage and assign in the portal.
      </p>

      <h3 className="mb-4">
        This enquiry is currently in the New Enquiry queue. Do you want to:
      </h3>

      <div className="flex flex-col md:flex-row gap-5">
        <div className="flex flex-col justify-between bg-off-white shadow-md p-6 flex-1 mr-6">
          <div>
            <h4 className="font-semibold mb-2">Send to all venues</h4>
            <p className="text-sm text-grey-darker mb-6">
              Auto-assign this enquiry with commission and send it directly to
              all venues to respond.
            </p>
          </div>
          {assigned ? (
            <div className="flex flex-col gap-3">
              <div className="flex items-center gap-2 text-green font-semibold">
                <i className="fas fa-check-circle" />
                <span>Sent to all venues</span>
              </div>
              <ButtonBrand
                Element={Link}
                to={`/admin/rfp/${rfpId}`}
                classes="w-full justify-center mt-2"
              >
                View RFP
              </ButtonBrand>
            </div>
          ) : (
            <div>
              <ButtonPrimary
                onClick={handleSendToVenues}
                disabled={assigning}
                classes="w-full justify-center"
              >
                {assigning ? "Sending..." : "Send to all venues"}
              </ButtonPrimary>
              {error && (
                <p className="text-warning text-sm mt-3">
                  Something went wrong. Please try again.
                </p>
              )}
            </div>
          )}
        </div>

        <div className="flex flex-col justify-between bg-off-white shadow-md p-6 flex-1">
          <div>
            <h4 className="font-semibold mb-2">Manage in the portal</h4>
            <p className="text-sm text-grey-darker mb-6">
              Assign the enquiry to a team member or manage it yourself in the
              admin portal.
            </p>
          </div>
          <ButtonBrand
            Element={Link}
            to="/admin/rfp?type=new"
            classes="w-full justify-center"
          >
            Manage the Enquiry
          </ButtonBrand>
        </div>
      </div>
    </div>
  );
};

export default AgentEnquirySuccess;
